// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ModalBody_modalBody__d8MBQ","hasVerticalScrollbar":"ModalBody_hasVerticalScrollbar__2ExVM"};